import React, { useContext } from 'react';
import { AppCtx } from "../../../AppCtx";
import './VerticalQuickMenuComponent.css';

// A higher-order component that transforms any button component 
// to fit in the vertical menu style
export const VerticalMenuButton = ({ children, title }) => {
  return (
    <div 
      className="vertical-menu-item" 
      title={title}
    >
      {children}
    </div>
  );
};

// The menu container component
const VerticalQuickMenuComponent = ({ children, visible }) => {
  return (
    <div 
      className="vertical-quick-menu"
      style={{
        opacity: visible ? 0.95 : 0,
        visibility: visible ? 'visible' : 'hidden'
      }}
    >
      {children}
    </div>
  );
};

export default VerticalQuickMenuComponent;
